import styled from 'styled-components'

import { device } from '@/common/constants/device'

import Text from '@/components/common/Text'
import WrapWithText from 'components/ui/WrapWithText'
import { useTranslations } from 'next-intl'

const firstList = [
  {
    src: 'search',
    title: 'applicationSearch',
    paragraph: 'applicationSearchP',
  },
  {
    src: 'chartbreakout',
    title: 'topPromotedApps',
    paragraph: 'topPromotedAppsP',
  },
  {
    src: 'switchvertical',
    title: 'sorting',
    paragraph: 'sortingP',
  },
]

const secondList = [
  {
    src: 'barchart',
    title: 'promotionDynamics',
    paragraph: 'promotionDynamicsP',
  },
  {
    src: 'chartbreakout',
    title: 'promotionStats',
    paragraph: 'promotionStatsP',
  },
  {
    src: 'clock',
    title: 'latestFoundCreatives',
    paragraph: 'latestFoundCreativesP',
  },
]

const Wrap = styled.section`
  position: relative;
  padding: 0.5rem;

  border-radius: 24px;
  background: #0e0e0e;

  @media ${device.tablet} {
    padding: 1rem;
  }

  @media ${device.laptop} {
    display: flex;
    justify-content: space-around;
    border-radius: 32px;
  }

  @media ${device.laptopL} {
    padding: 64px 108px;
    gap: 1rem;
  }
`

const Container = styled.div`
  padding: 3rem 1.625rem 2rem 1rem;
  border-radius: 24px;

  background: url('/_next_static/landing/offer/bg-top.png') top center/100% 62px
      no-repeat,
    #2b2b2b;

  :not(:last-child) {
    margin-bottom: 0.5rem;
  }

  @media ${device.tablet} {
    padding: 5.5rem 8.75rem 2.75rem 2.75rem;
    background-size: 100% 110px;

    :not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  @media ${device.laptop} {
    padding: 4.6875rem 1.5rem 2.0625rem 1.5rem;
    width: 466px;

    :not(:last-child) {
      margin-bottom: 0;
    }
  }

  @media ${device.laptopL} {
    width: 582px;
    background-size: 100% 75px;
  }
`

const Title = styled.h2`
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  font-weight: 800;
  font-size: 1.5em;
  line-height: 1.17;
  color: var(--white);
  letter-spacing: -0.02em;

  @media ${device.tablet} {
    margin-top: 1rem;
    margin-bottom: 32px;
    font-size: 2em;
    line-height: 46px;
  }
`

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 300px;

  :not(:last-child) {
    margin-bottom: 1.25rem;
  }

  @media ${device.tablet} {
    width: 504px;
  }

  @media ${device.laptop} {
    align-items: flex-start;
    width: 415px;
  }

  @media ${device.laptopL} {
    align-items: center;
  }
`

const Img = styled.div`
  background-image: url(${({ src }) => src});
  background-color: rgba(255, 255, 255, 0.08);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 15px;
  width: 30px;
  height: 30px;
  border-radius: 8px;

  @media ${device.tablet} {
    width: 50px;
    height: 50px;
    background-size: 24px;
  }
`

const ItemDescr = styled.div`
  width: 252px;

  @media ${device.tablet} {
    width: 432px;
  }

  @media ${device.laptop} {
    width: 346px;
  }
`

const ItemDescrTitle = styled.h3`
  margin-bottom: 2px;
  font-weight: 600;
  font-size: 1em;
  line-height: 1.5;
  color: var(--white);

  @media ${device.tablet} {
    font-size: 1.25em;
  }
`

const CustomText = styled(Text)`
  line-height: 1.66;
  letter-spacing: -0.01em;
  color: rgba(224, 225, 226, 0.54);
`

const Offer = () => {
  const t = useTranslations('index')

  return (
    <Wrap id="applications">
      <Container>
        <WrapWithText textKey="topPromotedApps" />
        <Title>{t('weOfferAVariety')}</Title>
        <div>
          {firstList.map(({ src, title, paragraph }) => (
            <Item key={title}>
              <Img src={`/_next_static/landing/offer/${src}.svg`} />
              <ItemDescr>
                <ItemDescrTitle>{t(title)}</ItemDescrTitle>
                <CustomText size="15" sizeT="18" weight="500">
                  {t(paragraph)}
                </CustomText>
              </ItemDescr>
            </Item>
          ))}
        </div>
      </Container>

      <Container>
        <WrapWithText textKey="applicationAnalysis" />
        <Title>{t('analizeEveryStep')}</Title>
        <div>
          {secondList.map(({ src, title, paragraph }) => (
            <Item key={title}>
              <Img src={`/_next_static/landing/offer/${src}.svg`} />
              <ItemDescr>
                <ItemDescrTitle>{t(title)}</ItemDescrTitle>
                <CustomText size="15" sizeT="18" weight="500">
                  {t(paragraph)}
                </CustomText>
              </ItemDescr>
            </Item>
          ))}
        </div>
      </Container>
    </Wrap>
  )
}

export default Offer
